import React, { useState } from "react";
import type { ProductItem } from "../../types/catalog";
import styles from "./ProductArtwork.module.css";
import { useI18n } from "../../i18n/I18n";

const categoryLabels: Record<ProductItem["type"], string> = {
  guitar: "Guitars",
  violin: "Strings",
  saxophone: "Winds",
  drums: "Drums",
};

interface ProductArtworkProps {
  product: ProductItem;
  large?: boolean;
}

function ProductArtwork({ product, large = false }: ProductArtworkProps) {
  const { language } = useI18n();
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = Boolean(product.img) && !imageFailed;

  return (
    <div className={`${styles.artwork} ${styles[product.type]} ${large ? styles.large : ""}`}>
      {showImage ? (
        <img src={product.img} alt={product.title} loading="lazy" onError={() => setImageFailed(true)} />
      ) : (
        <div className={styles.fallback} aria-label={`${product.brand}, ${language === "en" ? "photo coming soon" : "фото очікується"}`}>
          <span>{categoryLabels[product.type]}</span>
          <strong>{product.brand}</strong>
          <small>muzshop selection</small>
        </div>
      )}
    </div>
  );
}

export default ProductArtwork;
